{
  "home": "Inicio",
  "projects": "Proyectos",
  "my_tasks": "Mis tareas",
  "meetings": "Reuniones",
  "transcripts": "Transcripciones",
  "reports": "Reportes",
  "portfolio": "Portafolio",
  "billing": "Planes y facturación",
  "settings": "Configuración",
  "members": "Miembros",
  "departments": "Equipos",
  "menu": "Menú",
  "bottom_nav": "Navegación principal",
  "search_placeholder": "Buscar…",
  "search": {
    "searching": "Buscando…",
    "no_results_prefix": "Sin resultados para",
    "groups": {
      "projects": "Proyectos",
      "tasks": "Tareas",
      "people": "Personas"
    },
    "hint_navigate": "navegar",
    "hint_open": "abrir",
    "hint_close": "cerrar"
  },
  "sidebar": {
    "sections": {
      "favorites": "Favoritos",
      "departments": "Equipos",
      "projects": "Proyectos",
      "members": "Miembros"
    },
    "actions": {
      "new_department": "Nuevo equipo",
      "new_project": "Nuevo proyecto",
      "invite_member": "Invitar miembro",
      "view_all": "Ver todos",
      "expand": "Expandir sidebar",
      "collapse": "Colapsar sidebar"
    },
    "trial": {
      "label": "Trial Pro",
      "day": "día",
      "days": "días",
      "upgrade": "Actualizar →"
    }
  },
  "workspace": {
    "switch_title": "Cambiar de workspace",
    "count_switch": "{n} espacio · cambiar | {n} espacios · cambiar",
    "current": "Actual",
    "owner_badge": "Owner",
    "member_badge": "Miembro",
    "create_new": "Crear nuevo workspace",
    "modal": {
      "title": "Nuevo workspace",
      "subtitle": "Crea un espacio separado para otro proyecto, cliente o equipo. Tendrá sus propios proyectos, tareas y miembros.",
      "field_name": "Nombre del workspace",
      "placeholder": "Mi nuevo workspace",
      "cancel": "Cancelar",
      "submit": "Crear workspace",
      "submitting": "Creando…",
      "error_generic": "No se pudo crear el workspace."
    }
  },
  "create_menu": {
    "trigger": "Crear",
    "project": "Nuevo proyecto",
    "task": "Nueva tarea",
    "meeting": "Grabar reunión",
    "upload_recording": "Subir grabación",
    "invite_person": "Invitar persona"
  },
  "user_menu": {
    "theme": "Tema",
    "theme_light": "Claro",
    "theme_dark": "Oscuro",
    "theme_system": "Sistema",
    "workspace_members": "Miembros del workspace",
    "departments": "Equipos",
    "settings": "Configuración",
    "billing": "Plan y facturación",
    "download_android": "Descargar app Android",
    "logout": "Cerrar sesión"
  },
  "header": {
    "record_meeting": "Grabar reunión"
  },
  "palette": {
    "placeholder": "Buscar o crear una tarea…",
    "searching": "Buscando…",
    "empty_hint": "Escribe algo para buscar — o crear una tarea nueva.",
    "create_task_prefix": "Crear tarea: ",
    "ai_create_prefix": "✨ Crear con IA: ",
    "ai_subtitle": "La IA detectará prioridad, fecha y asignado del texto",
    "task_in_project": "en {project}",
    "actions": {
      "go_my_tasks": "Ir a Mis tareas",
      "go_projects": "Ir a Proyectos",
      "go_home": "Ir a Inicio"
    },
    "sections": {
      "create": "Crear",
      "projects": "Proyectos",
      "tasks": "Tareas",
      "people": "Personas",
      "shortcuts": "Atajos"
    },
    "shortcuts": {
      "navigate": "navegar",
      "open": "abrir",
      "open_palette": "abrir esto"
    }
  },
  "activity": "Actividad"
}
